/*********************************
 ****** REACT CONFIGURATION ******
 *********************************/
import React from "react";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import reportWebVitals from "reportWebVitals";
/*********************************
 ****** REDUX CONFIGURATION ******
 *********************************/
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store from "store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
/*****************
 ****** CSS ******
 *****************/
//@ts-ignore
import "index.css";

import App from "App";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "common";
import {
  AuthProvider,
  NotificationProvider,
  OrganizationsProvider,
  UtilityProvider,
} from "contexts";
import "cronstrue/locales/it";
import "cronstrue/locales/en";
import "cronstrue/locales/es";
import dayjs from "dayjs";
import "dayjs/locale/it";
import "dayjs/locale/en";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/es-pr";
import isBetween from "dayjs/plugin/isBetween"
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

/*****************
 ****** STRIPE ******
 *****************/
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import LinkedInTracking from "LinkedinTracking.jsx";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_DEVELOP_API_KEY);
// console.log(stripePromise)

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween)

const persistor = persistStore(store);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
// expose store when run in Cypress
if ((window as any).Cypress) {
  (window as any).store = store;
}

// Sentry.init({
//   dsn: process.env.REACT_APP_GLITCHTIP_DSN,
//   tracesSampleRate: 0.01, // 1% of transactions — adjust to your needs
//   environment: process.env.REACT_APP_ENV,
//   // autoSessionTracking: false, // GlitchTip does not support sessions
// });

// process.env.REACT_APP_GOOGLE_CLIENT_ID ||
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {process.env.REACT_APP_ENV !== "development" && <LinkedInTracking />}
    {/* <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}> */}
    <GoogleOAuthProvider
      clientId={
        "747487967968-dfsm83ba1opbv569osruc9mpqah3q666.apps.googleusercontent.com"
      }
    >
      <AuthProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <OrganizationsProvider>
              <UtilityProvider>
                <NotificationProvider>
                  <HashRouter>
                    <Elements stripe={stripePromise}>
                      <App />
                    </Elements>
                  </HashRouter>
                </NotificationProvider>
              </UtilityProvider>
            </OrganizationsProvider>
          </PersistGate>
        </Provider>
      </AuthProvider>
    </GoogleOAuthProvider>
    {/* </Sentry.ErrorBoundary> */}
  </ThemeProvider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
